module.exports = __webpack_public_path__ + "a9d8534e65a96a9d2a0c617c6b40cccb.svg";